import { Table } from "@radix-ui/themes";
import React from "react";

export interface AppTableProps {
    headers: any[],
    data: any[][],
	renderOption?: (key: string, value: any) => any
	style?: React.CSSProperties,
	classes?: string
}


export default function AppTable(props: AppTableProps) {
	const {headers, data, style, renderOption, classes} = props
    return (
        <Table.Root className={`${classes}`} style={{...style}}>
	<Table.Header>
		<Table.Row>
			{headers.map(item => {
				return (
					<Table.ColumnHeaderCell>{item}</Table.ColumnHeaderCell>
				)
			})}
			 
		</Table.Row>
	</Table.Header>

	<Table.Body>
		{data.map(item => {
			return (
			<Table.Row>
				{item.map(item => {
					return (
					renderOption ? renderOption(item[0], item[1]) : <Table.Cell>{item[1]}</Table.Cell> 
					)
				})}
			</Table.Row>
			)
		})}
		 
	</Table.Body>
</Table.Root>
    )
}